import ApiService from "@/core/services/api.service";

export default {
  get (query = {}) {
    return ApiService.query('auth/profile', query)
  },
  update (data = {}) {
    return ApiService.patch('auth/profile', data)
  }
}
